import hydraAccountBlue from "data/icons/hydra-account-blue.svg";
import hydraAccount from "data/icons/hydra-account.svg";
import phoneIconGray from "data/icons/phone-gray.svg";
import emailIconGray from "data/icons/email-gray.svg";
import { IContractor } from "store/contractors/contractors.types";

interface IProps {
  subcontractor: IContractor & { email: string };
}

const CaseSubContractorCard = ({ subcontractor }: IProps) => {
  return (
    <div className="customer-card">
      <div className="customer-card-title">
        <img
          alt=""
          className="customer-card-title-icon"
          src={ subcontractor?.has_account ? hydraAccountBlue : hydraAccount }
        />

        { subcontractor?.official_name }
      </div>

      <div>
        <img
          alt=""
          src={ phoneIconGray }
          style={ { marginRight: 5, marginBottom: -1 } }
        />

        <span>{ subcontractor?.phone_number }</span>
      </div>

      <div>
        <img
          alt=""
          src={ emailIconGray }
          style={ { marginRight: 5, marginBottom: -1 } }
        />

        <span>
          { subcontractor?.default_email || subcontractor?.email }
        </span>
      </div>
    </div>
  );
};

export default CaseSubContractorCard;
